import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { WebEncryptor } from "@songtradr-sso/shared/common";
import {
  Form,
  FormButtons,
  FormHeader,
  Input,
  NormalizedException,
  getRandomString,
} from "@songtradr-sso/shared/frontend";
import {
  Alert,
  Body,
  Button,
  ButtonLoadingIcon,
  Heading,
} from "@songtradr/design-language";
import { PageContainer } from "../../../components/page-container/PageContainer";
import {
  FormFields,
  forgotPassword,
  routes,
  schema,
  text,
} from "./ForgotPassword.Parts";

export const ForgotPassword = () => {
  const navigate = useNavigate();

  const formMethods = useForm<FormFields>({
    mode: "onSubmit",
    resolver: zodResolver(schema),
  });

  const {
    formState: { errors, isSubmitting },
    setError,
  } = formMethods;

  const onSubmit: SubmitHandler<FormFields> = async (data) => {
    try {
      await forgotPassword(data);
      const enc = getRandomString(32);
      const emlenc = await WebEncryptor.encrypt(data.email, enc);
      navigate(`${routes.password.verifyCode}?eml=${emlenc}:${enc}`);
    } catch (err) {
      setError("root", { message: new NormalizedException(err).message });
    }
  };

  return (
    <PageContainer floatTop backButton>
      <FormHeader>
        <Heading variant="h3-strong">{text.title}</Heading>
        <Body>{text.description}</Body>
      </FormHeader>
      <Form formMethods={formMethods} onSubmit={onSubmit}>
        <Heading variant="section">{text.inputLabel}</Heading>
        <Input
          id={text.shared.inputs.email.id}
          label={text.shared.inputs.email.label}
        />
        <Alert message={errors.root?.message} dismissible />
        <FormButtons>
          <Button $variant="important" type="submit" disabled={isSubmitting}>
            {isSubmitting ? <ButtonLoadingIcon /> : text.button}
          </Button>
        </FormButtons>
      </Form>
    </PageContainer>
  );
};
